import React, { memo } from 'react';
import { Switch, useRouteMatch } from 'react-router';
import { AdministrationRoute, PrivateRoute } from 'common/AuthRoute';
import { BusinessPartnerUsersPage } from 'pages/BusinessPartnerManagement/BusinessPartnerProfileOwnersManagement/BusinessPartnerProfileOwnersPage';
import { BusinessPartnerProfileOwnerManagementRoutes } from 'pages/BusinessPartnerManagement/BusinessPartnerProfileOwnersManagement/businessPartnerProfileOwnerManagementRoutes';
import { BusinessPartnerRegisterProfileOwnerPage } from 'pages/BusinessPartnerManagement/BusinessPartnerProfileOwnersManagement/BusinessPartnerRegisterProfileOwnerPage';
import { BusinessPartnerUserPage } from 'pages/BusinessPartnerManagement/BusinessPartnerProfileOwnersManagement/BusinessPartnerProfileOwnerPage';

export const BusinessPartnerUsersManagement = memo(() => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute exact path={path} component={BusinessPartnerUsersPage} />
      <AdministrationRoute
        exact
        path={`${path}/${BusinessPartnerProfileOwnerManagementRoutes.Register}`}
        component={BusinessPartnerRegisterProfileOwnerPage}
      />
      <PrivateRoute
        exact
        path={`${path}/${BusinessPartnerProfileOwnerManagementRoutes.Details}`}
        component={BusinessPartnerUserPage}
      />
    </Switch>
  );
});
